import { useState } from 'react'
import { InfoCard } from 'component-library'
import { useCheckBanner } from 'shared-utilities'
import Seo from '../../components/seo'
import DatasetBreadcrumbs from '../../components/DatasetBreadcrumbs/DatasetBreadcrumbs'
import LinkComponent from '../../components/LinkComponent/LinkComponent'
import MarkdownText from '../../components/MarkdownText/MarkdownText'
// import TagFilters from '../../components/TagFilters/TagFilters'

import './collection.scss'

type TDatasetFamily = {
  collectionSlug: string
  title: string
  previewImage: string
  slug: string
  tags: string[]
}

export default function CollectionPage({
  pageContext,
}: {
  pageContext: {
    slug: string
    title: string
    about: string
    families: TDatasetFamily[]
  }
}) {
  const { title, about, families } = pageContext

  const [isBannerPresent, setIsBannerPresent] = useState<boolean>(false)
  useCheckBanner(setIsBannerPresent)

  return (
    <div className="container">
      <DatasetBreadcrumbs
        categoryByCategorySlug={{
          name: title,
        }}
        className={`Collection__breadcrumbs ${
          isBannerPresent ? 'Collection__breadcrumbs--bannerPresent' : ''
        }`}
      />
      <section className="Collection__hero">
        <h1>{title}</h1>
        <MarkdownText text={about} />
      </section>
      <section className="Collection__datasets-wrapper">
        <div className="Collection__datasets">
          {families.map((datasetFamily, index) => (
            <LinkComponent
              key={`data-family-${datasetFamily.slug}-${index}`}
              href={`/${datasetFamily.slug}`}
              testId="data-family-link"
            >
              <InfoCard
                tag={
                  <>
                    <i className="bx bxs-data" /> Dataset
                  </>
                }
                label={datasetFamily.title}
                className="CategoryGroup__dataset"
                image={
                  !datasetFamily.previewImage ||
                  !datasetFamily.previewImage.includes('https://')
                    ? 'https://assets.cloud.pennylane.ai/datasets/generic/thumbnail/pennylane-datasets-thumbnail-generic.png'
                    : datasetFamily.previewImage
                }
              />
            </LinkComponent>
          ))}
        </div>
      </section>
    </div>
  )
}

export const Head = ({
  pageContext,
}: {
  pageContext: {
    slug: string
    title: string
    about: string
    previewImage: string
    families: TDatasetFamily[]
  }
}) => {
  return (
    <Seo
      title={pageContext.title}
      description={pageContext.about}
      image={pageContext.previewImage}
    />
  )
}
